import ProfileLikedPage from './ProfileLikedPage'

export default ProfileLikedPage
